import { AxiosResponse } from "axios";
import { axiosConfigV2 } from "../../config/api/configApiv2";
import { axiosConfigToUpload } from "../../config/api/configApiUpload";

export const getTestScheduleList: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/mooc-courses/search-schedule`, payload);
};

export const addTestSchedule: (payload: any) => Promise<AxiosResponse<any>> = (
  payload
) => {
  return axiosConfigV2.post(`/mooc-courses/create-schedule`, payload);
};

export const editTestSchedule: (
  scheduleId: number,
  payload: any
) => Promise<AxiosResponse<any>> = (scheduleId, payload) => {
  return axiosConfigV2.put(
    `/mooc-courses/update-schedule/${scheduleId}`,
    payload
  );
};

//danh sách lớp ghi danh để thêm lớp
export const getEnrollClassForAddSchedule: (
  id: any
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.get(`/mooc-courses/get-enrolled-class-by-unit-id/${id}`);
};

//danh sách lớp ghi danh để sửa
export const getEnrollClassForEditSchedule: (
  unitId: number,
  scheduleId: number
) => Promise<AxiosResponse<any>> = (unitId, scheduleId) => {
  return axiosConfigV2.get(
    `/mooc-courses/get-enrolled-class-by-unit-id-and-schedule-id/${unitId}/${scheduleId}`
  );
};

////danh sách tất cả lớp ghi danh
export const getEnrollClass: (payload: any) => Promise<AxiosResponse<any>> = (
  payload
) => {
  return axiosConfigV2.post(
    `/mooc-course-enroll-class/get-all-by-filter`,
    payload
  );
};

// lấy danh sachs giảng viên theo lớp
export const getAllTeacherInstruction: (
  courseId: number
) => Promise<AxiosResponse<any>> = (courseId) => {
  return axiosConfigV2.get(
    `/mooc-course-enroll-class/get-all-teacher-instruction?courseId=${courseId}`
  );
};

// lấy danh sachs học viên theo lớp
export const getStudentByEnrollClass: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(
    `/mooc-course-enroll-class/student/get-all-by-filter`,
    payload
  );
};

export const updateStudentScore: (
  blockId: number,
  classId: number,
  payload: any
) => Promise<AxiosResponse<any>> = (blockId, classId, payload) => {
  return axiosConfigV2.put(
    `/mooc-course-enroll-class/student/change-score/${blockId}/${classId}`,
    payload
  );
};

// tải file mẫu
export const downloadScoreTemplate: (
  classId: number,
  blockId: number
) => Promise<AxiosResponse<any>> = (classId, blockId) => {
  return axiosConfigV2.get(
    `/mooc-course-enroll-class/student/download-template-marking?enrollClassId=${classId}&blockId=${blockId}`,
    { responseType: "arraybuffer" }
  );
};

export const downloadScoreList: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(
    `/mooc-course-enroll-class/student/export`,
    payload,
    { responseType: "arraybuffer" }
  );
};

export const importScoreTemplate: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigToUpload.post(
    `/mooc-course-enroll-class/student/import-excel-marking`,
    payload,
    { responseType: "arraybuffer" }
  );
};

// Gửi kết quả
export const sendScoreResult: (payload: any) => Promise<AxiosResponse<any>> = (
  payload
) => {
  return axiosConfigV2.get(
    `mooc-course-enroll-class/student/send-marking?${payload}`
  );
};

// lịch sử chinhr sửa

export const getHistoryEditScore: (
  blockId: number,
  classId: number
) => Promise<AxiosResponse<any>> = (blockId, classId) => {
  return axiosConfigV2.get(
    `mooc-course-enroll-class/student/history-modify-score/${blockId}/${classId}`
  );
};
